import {
  IHarvestResource,
  IMusselHarvest,
  IOysterHarvest,
  ISeaweedHarvest,
} from '../../../entities/growing.entities';
import MusselHarvestViewModal from './MusselHarvestViewModal';
import OysterHarvestViewModal from './OysterHarvestViewModal';
import SeaweedHarvestViewModal from './SeaweedHarvestViewModal';

interface Props {
  visible: boolean;
  harvest: IHarvestResource;
  onClose: () => void;
}

const HarvestViewModal = ({ visible, harvest, onClose }: Props) => (
  <>
    {harvest.crop_type === 'MUSSEL' ? (
      <MusselHarvestViewModal
        visible={visible}
        harvest={harvest as IMusselHarvest}
        onClose={onClose}
      />
    ) : harvest.crop_type === 'OYSTER' ? (
      <OysterHarvestViewModal
        visible={visible}
        harvest={harvest as IOysterHarvest}
        onClose={onClose}
      />
    ) : harvest.crop_type === 'SEAWEED' ? (
      <SeaweedHarvestViewModal
        visible={visible}
        harvest={harvest as ISeaweedHarvest}
        onClose={onClose}
      />
    ) : (
      <></>
    )}
  </>
);

export default HarvestViewModal;
